<template>
    <v-list-tile @click="imprimir">
        <v-list-tile-content>
            <v-list-tile-title v-html="'Histórico Transferegov.br'"></v-list-tile-title>
        </v-list-tile-content>
    </v-list-tile>
</template>

<script>
    import {mapState} from 'vuex'
    import {actionTypes} from '@/commons/constants'
    import store from '../../../../../commons/store'

    export default {
        name: 'LicitacaoAtualizacaoAcoesImprimirHistoricoMaisBrasil',
        data() {
            return {
                mostrarDialogExclusao: false
            }
        },
        methods: {
            async imprimir() {
                try {
                    this.setMensagemLoading('Gerando relatório...')
                    await store.dispatch(actionTypes.IMPRIMIR_HISTORICO_MAIS_BRASIL, {licitacaoId : this.licitacao.id})
                    this.mostrarNotificacaoSucessoDefault()
                    this.desabilitarLoading()
                } catch (e) {
                    this.desabilitarLoadingGlobal()
                }
            }
        },
        computed: {
            ...mapState(['licitacao'])
        }
    }
</script>